import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { DataDirectoryList } from './components/DataDirectoryList'
import { SFTPConfigList } from './components/SFTPConfigList'
import DocumentTitle from 'react-document-title'
import { useIntl } from 'react-intl'
import { GeneralParametersList } from './components/GeneralParametersList'
import { EnergyTypesList } from './components/EnergyTypesList'
import { EnergySubtypesList } from './components/EnergySubtypesList'
import ConversionFactorsList from './components/ConversionFactorsList'
import { SiteFeaturesList } from './components/SiteFeaturesList'
import { TaskCategoriesList } from './components/TaskCategoriesList'
import { TaskSubjectsList } from './components/TaskSubjectsList'
import { ImportFileTemplateSettingList } from './components/ImportFileTemplateSettingList'
import { EventTypesList } from './components/EventTypesList'

const settingsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Settings',
    path: '/settings/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SettingsPage = () => {
  const intl = useIntl()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='data-directory'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Data Directory List'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSDATADIRECTORY' })}
              </PageTitle>
              <DataDirectoryList />
            </>
          }
        />
        <Route
          path='sftp-config'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | SFTP Config'}></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSSFTPCONFIG' })}
              </PageTitle>
              <SFTPConfigList />
            </>
          }
        />

        <Route
          path='general-parameters'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | General Parameters'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSGENERALPARAMETERS' })}
              </PageTitle>
              <GeneralParametersList />
            </>
          }
        />
        <Route
          path='conversion-factors'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Conversion Factors'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSCONVERSIONFACTORS' })}
              </PageTitle>
              <ConversionFactorsList />
            </>
          }
        />
        <Route
          path='energy-types'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Energy Types'}></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSENERGYTYPES' })}
              </PageTitle>
              <EnergyTypesList />
            </>
          }
        />
        <Route
          path='energy-subtypes'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Energy Subtypes'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGSENERGYSUBTYPES' })}
              </PageTitle>
              <EnergySubtypesList />
            </>
          }
        />
        <Route
          path='site-features'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Site Benchmark Parameters'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>Benchmark Parameters</PageTitle>
              <SiteFeaturesList />
            </>
          }
        />
        <Route
          path='task_categories'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Task Categories'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGS.TASKCATEGORIES' })}
              </PageTitle>
              <TaskCategoriesList />
            </>
          }
        />
        <Route
          path='task_subjects'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Task Subjects'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGS.TASKSUBJECTS' })}
              </PageTitle>
              <TaskSubjectsList />
            </>
          }
        />
        <Route
          path='import-file-template'
          element={
            <>
              <DocumentTitle
                title={process.env.REACT_APP_NAME + ' | Import File Structure Template'}
              ></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGS.IMPORTFILESTRUCTURETEMPLATE' })}
              </PageTitle>
              <ImportFileTemplateSettingList />
            </>
          }
        />
        <Route
          path='event-types'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Event Types'}></DocumentTitle>
              <PageTitle breadcrumbs={settingsBreadCrumbs}>
                {intl.formatMessage({ id: 'MENU.SETTINGS.EVENTTYPES' })}
              </PageTitle>
              <EventTypesList />
            </>
          }
        />

        <Route index element={<Navigate to='/settings/data-directory' />} />
      </Route>
    </Routes>
  )
}

export default SettingsPage
